<template>
    <!-- 学校使用率 -->
    <Row :gutter="10" class="school-main">
        <div style="font-size:14px;font-weight: 800;float: left;">学校使用率</div>
        <!-- 月份选择器 -->
        <Row class="ratio-data-selected">
            <Col :xs="10" :sm="10" :md="8" :lg="4" :xl="6" style="float: right;">
                请选择月份:
                <Select
                    v-model="month"
                    placeholder="请选择月份"
                    @on-change="search"
                    style="width: 140px;margin-left: 10px;"
                >
                    <Option
                        v-for="item in monthList"
                        :value="item.state_month"
                        :key="item.state_month"
                    >{{ item.state_month }}
                    </Option>
                </Select>
            </Col>
        </Row>
        <!-- 表格 -->
        <Row
            :gutter="10"
            style="margin-top: 5px;font-size:14px;"
            v-if="Object.keys(schoolUseObj).length != 0"
        >
            <Col span="8">统计月份:{{schoolUseObj.stateMonth}}</Col>
            <Col span="8">教师总数:{{schoolUseObj.teaCount}}</Col>
            <Col span="8">大屏总数:{{schoolUseObj.screenCount}}</Col>
        </Row>
        <Row v-if="Object.keys(schoolUseObj).length === 0" class="no-ratio-data">
            <span>暂无数据</span>
        </Row>
        <Row :gutter="10" style="margin-top: 10px;" v-else>
            <Table :columns="columns" :data="schoolUseData"></Table>
            <!-- 产品使用率规则计算弹框 -->
            <Modal v-model="screenRuleVisible" title="大屏使用率计算规则">
                <p class="pro-use-rule-modal-text">计算每月使用4次以上的大屏数量/每月大屏使用1次以上的总数量</p>
            </Modal>
            <Modal v-model="pcRuleVisible" title="PC使用率计算规则">
                <p class="pro-use-rule-modal-text">计算每月使用4次以上的PC数量/每月PC使用1次以上的总数量</p>
            </Modal>
            <Modal v-model="mobileRuleVisible" title="移动授课助手使用率计算规则">
                <p class="pro-use-rule-modal-text">计算每月使用4次以上的移动授课数量/每月移动授课助手使用1次以上的总数量</p>
            </Modal>
            <Modal v-model="assistantRuleVisible" title="备课使用率计算规则">
                <p class="pro-use-rule-modal-text">计算每月使用4次以上的备课数量/每月备课使用1次以上的总数量</p>
            </Modal>
            <Modal v-model="homeworkRuleVisible" title="作业使用率计算规则">
                <p class="pro-use-rule-modal-text">计算每月布置作业4次以上数量/每月布置作业1次以上的总数量</p>
            </Modal>
            <Modal v-model="seedRuleVisible" title="种子用户数计算规则">
                <p class="pro-use-rule-modal-text">计算每月种子用户使用超过4次以上的数量/每月种子用户使用超过1次以上的数量</p>
            </Modal>
        </Row>
    </Row>
</template>
<script>
    import {findSchoolUsageRate, findDateMonth} from "../../../service/api.js";

    export default {
        name: "ratio-modal",
        props:{
            startDate:String,
            endDate:String
        },
        data () {
            return {
                schoolId: this.$route.query.schoolId, //学校ID
                screenRuleVisible: false, //默认大屏使用率计算规则弹框不显示
                pcRuleVisible: false, //默认PC使用率计算规则弹框不显示
                mobileRuleVisible: false, //默认移动授课助手使用率计算规则弹框不显示
                assistantRuleVisible: false, //默认备课助手使用率计算规则弹框不显示
                homeworkRuleVisible: false, //默认作业使用率计算规则弹框不显示
                seedRuleVisible: false, //默认种子用户数计算规则弹框不显示
                columns: [
                    {
                        title: "产品",
                        key: "name",
                        render: (h, params) => {
                            return h("div", [
                                h(
                                    "a",
                                    {
                                        attrs: {
                                            title: "点击查看产品使用率计算规则",
                                            //让超链接执行一个js函数，而不是跳转到一个地址
                                            href: "javascript:void(0);"
                                        },
                                        style: {
                                            color: "#515a6e",
                                            fontSize: "12px"
                                        },
                                        on: {
                                            click: () => {
                                                this.lookComputeRule(params.row, params.index);
                                            }
                                            // mouseover: val => {
                                            //     this.lookComputeRule(params.row, params.index);
                                            // }
                                        }
                                    },
                                    params.row.name
                                ),
                                // 添加图片
                                h("img", {
                                    attrs: {
                                        title: "点击查看产品使用率计算规则",
                                        src: "/ratio-rule.png"
                                    },
                                    style: {
                                        cursor: "pointer"
                                    },
                                    on: {
                                        click: () => {
                                            this.lookComputeRule(params.row, params.index);
                                        }
                                        // mouseover: val => {
                                        //     this.lookComputeRule(params.row, params.index);
                                        // }
                                    }
                                })
                            ]);
                        }
                    },
                    {
                        title: "活跃数量",
                        key: "count",
                        align: "center",
                        render: (h, params) => {
                            return h("div", [
                                h(
                                    "a",
                                    {
                                        attrs: {
                                            title: "查看产品使用超过四次的用户详情",
                                            href: "javascript:void(0);"
                                        },
                                        style: {
                                            color: "bule",
                                            fontSize: "14px"
                                        },
                                        on: {
                                            click: () => {
                                                this.lookProUserDetails(params.row,'activeUserDetails');
                                            }
                                        }
                                    },
                                    params.row.count
                                )
                            ]);
                        }
                    },
                    {
                        title: "使用总数",
                        key: "allCount",
                        align: "center",
                        render: (h, params) => {
                            return h("div", [
                                h(
                                    "a",
                                    {
                                        attrs: {
                                            title: "查看用户使用产品详情",
                                            href: "javascript:void(0);"
                                        },
                                        style: {
                                            color: "bule",
                                            fontSize: "14px"
                                        },
                                        on: {
                                            click: () => {
                                                this.lookProUserDetails(params.row, 'userDetails');
                                            }
                                        }
                                    },
                                    params.row.allCount
                                )
                            ]);
                        }
                    },
                    {
                        title: "使用率",
                        key: "ratio",
                        align: "center"
                    }
                ],
                schoolUseData: [],
                schoolUseObj: {},
                monthList: [],
                month: 0
            };
        },
        methods: {
            /**
             * 点击查看产品使用详情
             */
            lookProUserDetails (row, name) {
                this.$router.push({
                    name: "useProRateDetails",
                    query: {
                        schoolId: this.schoolId,
                        schoolName: this.schoolName,
                        startTime: this.startDate,
                        endTime: this.endDate,
                        timeKey: this.month,
                        proName:row.name,
                        tabsName:name
                    }
                });
            },
            /**
             * 点击查看产品使用率的计算规则
             */
            lookComputeRule (index) {
                //index:0,查看大屏使用率计算规则
                if (index._index == 0) {
                    this.screenRuleVisible = true;
                } else if (index._index == 1) {
                    //index:1,查看PC使用率计算规则
                    this.pcRuleVisible = true;
                } else if (index._index == 2) {
                    //index:2,查看移动授课助手使用率计算规则
                    this.mobileRuleVisible = true;
                } else if (index._index == 3) {
                    //index:3,查看备课助手使用率计算规则
                    this.assistantRuleVisible = true;
                } else if (index._index == 4) {
                    //index:4,查看作业使用率计算规则
                    this.homeworkRuleVisible = true;
                } else {
                    //index:5,查看种子用户数计算规则
                    this.seedRuleVisible = true;
                }
            },
            /**
             * 查询按钮点击事件
             */
            search () {
                //选择完日期后重新请求接口
                this.getSchoolUsageRate();
            },

            /**
             * 获取日期下拉框数据
             */
            async getDateMonth () {
                let _this = this;
                await findDateMonth()
                    .then(function (data) {
                        _this.monthList = data.Date;
                        _this.month = _this.monthList[0].state_month;
                        //获取学校使用率
                        _this.getSchoolUsageRate();
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取学校使用率列表
             */
            async getSchoolUsageRate () {
                let _this = this;
                let params = {
                    schoolId: _this.schoolId,
                    Date: _this.month
                };
                await findSchoolUsageRate(params)
                    .then(function (data) {
                        _this.schoolUseObj = data;
                        let curSchUseData = data.rateInfo;
                        if (data !== "") {
                            for (let i = 0; i < curSchUseData.length; i++) {
                                curSchUseData[i].ratio = curSchUseData[i].ratio + '%'
                            }
                        }
                        _this.schoolUseData = curSchUseData;
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            }
        },
        mounted () {
            this.getDateMonth();
        }
    };
</script>

<style lang="scss" scoped>
    .pro-use-rule-modal-text {
        font-size: 16px;
    }

    .no-ratio-data {
        width: 1858px;
        height: 150px;
        text-align: center;
        line-height: 150px;
        margin-top: 10px;
        border: 1px solid #ddd;
    }

    .ratio-data-selected {
        .ivu-col-span-xl-6 {
            padding-left: 190px;
        }
    }
</style>
<style lang="scss">
    .school-main {
        .ivu-col-span-xl-6 {
            display: block;
            width: 30%;
        }
    }
</style>
